import React from 'react';
import { ControlledRadioButton } from '@@viewCommonComponents/controlled/index.js';
import booleanOptions from '@@viewCommonComponents/forms/options/index.js';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';

const SimulationNeedsSelfEmployed = ({ getMiddleText, getMiddleBoolean, form, collectionNeedChoices }) => {
  return (
    <>
      <ControlledRadioButton
        name={'collectionNeeds.0.protectionNeeds.0.code'}
        label={getMiddleText('RECUEIL_BESOIN_CHOIX_LABEL')}
        rules={isRequiredSelect(collectionNeedChoices, true)}
        form={form}
        className={'grid gap-[10px]'}
        options={collectionNeedChoices}
        isMultiline
        isDisplayed={getMiddleBoolean('RECUEIL_BESOIN_CHOIX_EST_NECESSAIRE')}
      />
      <div className="mt-4 mb-4 row-start-2">
        <ControlledRadioButton
          label={getMiddleText('RECUEIL_BESOIN_QUESTION')}
          id="contractOnGoing"
          name="contractOnGoing"
          form={form}
          options={booleanOptions}
          booleanValue
          data-testid="contractOnGoing"
        />
      </div>
    </>
  );
};

export default SimulationNeedsSelfEmployed;
